import { Icon } from "@design-system/Icon";
import { Box } from "@design-system/Layout/Box";
import { FlexCol, FlexRow } from "@design-system/Layout/Flex";
import { Text, type TextProps } from "@design-system/Typography/Text";
import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { RESOURCE_NAME, keys } from "../../i18n";

export type LoadingState =
    | "analyzing_questionnaire"
    | "searching_for_answer"
    | "all_questions_extracted";

const isValidLoadingState = (state: string): state is LoadingState => {
    return [
        "analyzing_questionnaire",
        "searching_for_answer",
        "all_questions_extracted",
    ].includes(state);
};

export const Loader: FC<TextProps & { title?: string }> = ({ title }) => {
    const { t } = useTranslation(RESOURCE_NAME);

    const validatedLoadingText =
        title && isValidLoadingState(title) ? title : null;

    return (
        <FlexCol className="bg-gradient-to-r from-[#C238CC] to-[#B554F2] rounded-xl p-[1px] w-full">
            <FlexCol
                className="bg-accent-1-50 rounded-xl max-h-[5000px] transition-max-height duration-500 ease-in-out overflow-hidden"
                gap="1"
            >
                <FlexRow
                    alignItems="center"
                    justifyContent="center"
                    gap="1"
                    as="header"
                    className="p-4"
                >
                    <FlexRow gap="1">
                        <Box
                            className="flex"
                            alignItems="center"
                            justifyContent="center"
                            w="5"
                            h="5"
                        >
                            <Icon
                                name="stars"
                                size="sm"
                                className="text-accent-1-400 animate-pulse"
                            />
                        </Box>

                        <Text
                            variant="body-sm-bold"
                            className="bg-gradient-to-r from-[#C238CC] to-[#B554F2] bg-clip-text text-transparent animate-pulse"
                        >
                            {validatedLoadingText
                                ? t(keys[validatedLoadingText])
                                : title}
                        </Text>
                    </FlexRow>
                </FlexRow>
            </FlexCol>
        </FlexCol>
    );
};
